import { observer } from 'mobx-react';
import MealGroup from '../../components/MealGroup/MealGroup';
import mealsStore from '../../store/mealsStore';
import integrationsStore from 'src/mobx/integrationStore';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';
import './style.scss';

const MealGroups: React.FC = observer((): JSX.Element | null => {
  if (!mealsStore.meal?.sizes.length) return null;

  return (
    <ul className="d-flex flex-column mt-4">
      {mealsStore.meal?.groups.map((group) => (
        <MealGroup key={group.id} group={group} />
      ))}
      <IntegrationManager
        setting={integrationsStore.posRestrictions?.comboMealGroupCreate}
        wrapperClassName="mt-6"
        tooltipOptions={{ wrapperClassName: 'meal-groups__btn-wrapper' }}
        withTooltip
      >
        <Button title={localeStore.t('add_group')} onClick={mealsStore.addGroup} appearance="tertiary" stretched className="meal-groups__btn-add" />
      </IntegrationManager>
    </ul>
  );
});

export default MealGroups;
